export default __webpack_public_path__ + "static/tictactrip-c08258a0f9d6b8c128c2b9b543941212.svg";